export default __webpack_public_path__ + "static/media/westerpark.3b802e00.jpg";